export default function Terms() {
  return (
    <div style={{ fontFamily: '-apple-system,BlinkMacSystemFont,sans-serif', maxWidth: '800px', margin: '0 auto', padding: '3rem 2rem', color: '#1a1a1a', lineHeight: '1.8' }}>
      <div style={{ marginBottom: '2rem' }}>
        <a href="/" style={{ color: '#666', fontSize: '14px', textDecoration: 'none' }}>← Back to SellerDash</a>
      </div>
      <h1 style={{ fontSize: '32px', fontWeight: '600', marginBottom: '0.5rem' }}>Terms of Service</h1>
      <p style={{ color: '#888', fontSize: '14px', marginBottom: '3rem' }}>Last updated: 22 May 2026</p>

      <section style={{ marginBottom: '2rem' }}>
        <h2 style={{ fontSize: '20px', fontWeight: '600', marginBottom: '1rem' }}>1. Agreement</h2>
        <p>By using SellerDash you agree to these Terms of Service. SellerDash is operated by Rozac Ltd, United Kingdom. If you do not agree to these terms, do not use SellerDash.</p>
      </section>

      <section style={{ marginBottom: '2rem' }}>
        <h2 style={{ fontSize: '20px', fontWeight: '600', marginBottom: '1rem' }}>2. The service</h2>
        <p>SellerDash provides a dashboard for Amazon FBA sellers to track sales, fees, inventory and profit data. We connect to Amazon's Selling Partner API on your behalf to retrieve your data.</p>
        <p>SellerDash is a tool to help you understand your business data. It is not financial or tax advice. Always consult a qualified accountant for tax matters.</p>
      </section>

      <section style={{ marginBottom: '2rem' }}>
        <h2 style={{ fontSize: '20px', fontWeight: '600', marginBottom: '1rem' }}>3. Your account</h2>
        <ul style={{ paddingLeft: '1.5rem' }}>
          <li style={{ marginBottom: '0.5rem' }}>You must be 18 or over to use SellerDash</li>
          <li style={{ marginBottom: '0.5rem' }}>You are responsible for keeping your account credentials secure</li>
          <li style={{ marginBottom: '0.5rem' }}>You must be a legitimate Amazon seller to use this service</li>
          <li style={{ marginBottom: '0.5rem' }}>One account per seller — do not share accounts</li>
        </ul>
      </section>

      <section style={{ marginBottom: '2rem' }}>
        <h2 style={{ fontSize: '20px', fontWeight: '600', marginBottom: '1rem' }}>4. Subscription and payment</h2>
        <ul style={{ paddingLeft: '1.5rem' }}>
          <li style={{ marginBottom: '0.5rem' }}>SellerDash costs £10 per month after a 14-day free trial</li>
          <li style={{ marginBottom: '0.5rem' }}>No credit card required for the free trial</li>
          <li style={{ marginBottom: '0.5rem' }}>Subscriptions renew automatically each month</li>
          <li style={{ marginBottom: '0.5rem' }}>You can cancel at any time — no cancellation fees</li>
          <li style={{ marginBottom: '0.5rem' }}>Refunds are handled on a case-by-case basis — contact support</li>
          <li style={{ marginBottom: '0.5rem' }}>Payments are processed by Stripe</li>
        </ul>
      </section>

      <section style={{ marginBottom: '2rem' }}>
        <h2 style={{ fontSize: '20px', fontWeight: '600', marginBottom: '1rem' }}>5. Amazon data</h2>
        <p>By connecting your Amazon store you authorise SellerDash to access your Amazon seller data via SP-API. You can revoke this access at any time through Amazon Seller Central. We use your Amazon data only to provide the SellerDash service to you.</p>
      </section>

      <section style={{ marginBottom: '2rem' }}>
        <h2 style={{ fontSize: '20px', fontWeight: '600', marginBottom: '1rem' }}>6. Acceptable use</h2>
        <p>You must not:</p>
        <ul style={{ paddingLeft: '1.5rem' }}>
          <li style={{ marginBottom: '0.5rem' }}>Use SellerDash for any illegal purpose</li>
          <li style={{ marginBottom: '0.5rem' }}>Attempt to reverse engineer or copy the service</li>
          <li style={{ marginBottom: '0.5rem' }}>Share your account with others</li>
          <li style={{ marginBottom: '0.5rem' }}>Attempt to access other users' data</li>
          <li style={{ marginBottom: '0.5rem' }}>Use the service in a way that violates Amazon's terms of service</li>
        </ul>
      </section>

      <section style={{ marginBottom: '2rem' }}>
        <h2 style={{ fontSize: '20px', fontWeight: '600', marginBottom: '1rem' }}>7. Data accuracy</h2>
        <p>SellerDash displays data retrieved from Amazon's SP-API. While we strive for accuracy, data may be delayed or incomplete due to Amazon's settlement processes. Fee data typically settles 3-7 days after orders. Do not rely solely on SellerDash for financial decisions — always verify with Amazon Seller Central.</p>
      </section>

      <section style={{ marginBottom: '2rem' }}>
        <h2 style={{ fontSize: '20px', fontWeight: '600', marginBottom: '1rem' }}>8. Service availability</h2>
        <p>We aim for 99% uptime but cannot guarantee uninterrupted service. We are not liable for losses caused by service downtime or data inaccuracies. We may perform maintenance which temporarily interrupts the service.</p>
      </section>

      <section style={{ marginBottom: '2rem' }}>
        <h2 style={{ fontSize: '20px', fontWeight: '600', marginBottom: '1rem' }}>9. Termination</h2>
        <p>You can cancel your account at any time by contacting support. We may suspend or terminate accounts that violate these terms. On termination, your data will be deleted within 30 days.</p>
      </section>

      <section style={{ marginBottom: '2rem' }}>
        <h2 style={{ fontSize: '20px', fontWeight: '600', marginBottom: '1rem' }}>10. Limitation of liability</h2>
        <p>SellerDash is provided "as is". To the maximum extent permitted by law, Rozac Ltd is not liable for any indirect, incidental, or consequential damages arising from use of the service. Our total liability is limited to the amount you paid us in the last 3 months.</p>
      </section>

      <section style={{ marginBottom: '2rem' }}>
        <h2 style={{ fontSize: '20px', fontWeight: '600', marginBottom: '1rem' }}>11. Governing law</h2>
        <p>These terms are governed by the laws of England and Wales. Any disputes will be resolved in the courts of England and Wales.</p>
      </section>

      <section style={{ marginBottom: '2rem' }}>
        <h2 style={{ fontSize: '20px', fontWeight: '600', marginBottom: '1rem' }}>12. Contact</h2>
        <p><strong>Rozac Ltd</strong><br />
        Email: <a href="mailto:support@knotyourtype.co.uk" style={{ color: '#378ADD' }}>support@knotyourtype.co.uk</a></p>
      </section>
    </div>
  );
}